import { render, staticRenderFns } from "./Computed.vue?vue&type=template&id=54449741&scoped=true&"
import script from "./Computed.vue?vue&type=script&lang=js&"
export * from "./Computed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54449741",
  null
  
)

export default component.exports